var $ = require('jquery');
var util = require('./util');

var loadedIds = {};
function comments(postId, fullUrl, isMobile) {
  var container = document.querySelector('#disqus_thread_' + postId);

  // Comments are disabled!
  if (!container) {
    return;
  }

  var $container = $(container);

  util.scrollWatcher($container, 0, function (event) {
    if (event === 'enter' && !(postId in loadedIds)) {
      $container.text('');
      setupSpotComments(postId, container, fullUrl);
      loadedIds[postId] = 1;
    }
  });
}

function setupSpotComments(postId, container, fullUrl) {
  var spotId = /2018\=1/.test(window.location.href) ? 'sp_zHBUrI2e' : 'sp_64ufMw0S';

  var recirculationScript = document.createElement('script');
  recirculationScript.setAttribute('async', 'true');
  recirculationScript.setAttribute('src', 'https://recirculation.spot.im/spot/' + spotId);

  var conversationScript = document.createElement('script');
  conversationScript.setAttribute('async', 'true');
  conversationScript.setAttribute('src', 'https://launcher.spot.im/spot/' + spotId);
  conversationScript.setAttribute('data-spotim-module', 'spotim-launcher');
  conversationScript.setAttribute('data-post-url', fullUrl);
  conversationScript.setAttribute('data-post-id', postId);

  var metaTags = document.querySelector('meta[name="keywords"]');
  if (metaTags) {
    conversationScript.setAttribute('data-article-tags', metaTags.getAttribute('content'));
  }
  conversationScript.setAttribute('data-disqus-url', fullUrl);
  conversationScript.setAttribute('data-disqus-url', fullUrl);
  conversationScript.setAttribute('data-disqus-identifier', postId + ' http://www.theinertia.com/?p=' + postId);

  // append the elements to the container:
  var sibling = document.createElement('div');
  container.parentNode.insertBefore(sibling, container.nextSibling);

  var frag = document.createDocumentFragment();
  frag.appendChild(recirculationScript);
  frag.appendChild(conversationScript);
  sibling.appendChild(frag);
}

module.exports = comments;
